<script lang="ts" setup>
import { LightSwitchField } from '@vue-interface/light-switch-field';
import type { MgDataVariable } from 'types';
import { computed, watchEffect } from 'vue';

const props = defineProps<{
    id: string,
    name: string,
    item: MgDataVariable,
    index: number,
    errors: Record<string, string>,
    modelValue: string
}>();

const emit = defineEmits<{
    'update:modelValue': [value: string],
    'update:formattedValue': [value: string],
    'update:readableValue': [value: string]
}>();

const model = computed({
    get() {
        return props.modelValue;
    },
    set(value: string) {
        emit('update:modelValue', value);
    }
});

const isDefault = computed(() => {
    return model.value === props.item.defaultValue;
});

watchEffect(() => {
    emit('update:formattedValue', model.value);
    emit('update:readableValue', model.value);
});

</script>

<template>
    <div class="flex items-center gap-x-2">
        <LightSwitchField
            :id="id"
            v-model="model"
            :name="name"
            :error="errors[name]"
            off-value="false"
            on-value="true"
            class="w-full"
            size="form-switch-xs" />
        <slot
            v-if="!isDefault"
            name="reset" />
    </div>
</template>